'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alpha", "favorites", "fieldsetSize", "hex", "hexOnly", "hue", "includeAlpha", "mode", "onChange", "onFocus", "onBlur", "cssStyles"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'foundations-theming/utils';
import Board from './Board';
import Preview from './Preview';
import Ribbon from './Ribbon';
import AlphaRibbon from './AlphaRibbon';
import Params from './Params';
import FavoritesAccordion from './FavoritesAccordion';
import { filterProps } from 'foundations-components/utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PanelContainer = styled.div.withConfig({
  displayName: "Panel__PanelContainer",
  componentId: "tmfmj3-0"
})(({
  theme,
  $cssStyles
}) => Object.assign({
  display: 'flex',
  position: 'relative',
  padding: theme.space['200']
}, $cssStyles));
const PanelInner = styled.div.withConfig({
  displayName: "Panel__PanelInner",
  componentId: "tmfmj3-1"
})(["width:146px;display:flex;flex-direction:column;"]);
const RibbonContainer = styled.div.withConfig({
  displayName: "Panel__RibbonContainer",
  componentId: "tmfmj3-2"
})(({
  theme
}) => ({
  display: 'flex',
  flexShrink: 0,
  marginTop: theme.space['200']
}));
const RibbonInner = styled.div.withConfig({
  displayName: "Panel__RibbonInner",
  componentId: "tmfmj3-3"
})(({
  theme
}) => ({
  flexGrow: 1,
  marginRight: theme.space['200']
}));
export default class Panel extends Component {
  constructor(...args) {
    super(...args);
    this.onSystemColorPickerOpen = evt => {
      // only works with browsers that support color input
      if (evt.target.type === 'color') {
        this.systemColorPickerOpen = true;
      }
    };
    this.onFocus = () => {
      if (this._blurTimer) {
        clearTimeout(this._blurTimer);
        this._blurTimer = null;
      } else {
        this.props.onFocus();
      }
    };
    this.onBlur = () => {
      if (this._blurTimer) {
        clearTimeout(this._blurTimer);
      }
      this._blurTimer = setTimeout(() => {
        // if is system color picker open, then stop run blur
        if (this.systemColorPickerOpen) {
          this.systemColorPickerOpen = false;
          return;
        }
        this.props.onBlur();
      }, 100);
    };
  }
  renderAlpha({
    alpha,
    hex,
    includeAlpha,
    onChange
  }) {
    if (!includeAlpha) return null;
    return /*#__PURE__*/_jsx(AlphaRibbon, {
      alpha: alpha,
      hex: hex,
      onChange: onChange
    });
  }
  render() {
    const _this$props = this.props,
      {
        alpha,
        favorites,
        fieldsetSize,
        hex,
        hexOnly,
        hue,
        includeAlpha,
        mode,
        onChange,
        cssStyles
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      domProps
    } = filterProps(rest);

    // @bend-expect trellis-tokenized
    return /*#__PURE__*/_jsxs(PanelContainer, Object.assign({}, domProps, {
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      tabIndex: "0",
      $cssStyles: cssStyles,
      children: [/*#__PURE__*/_jsxs(PanelInner, {
        "data-test-id": "panel-inner",
        children: [/*#__PURE__*/_jsx(Board, {
          hex: hex,
          hue: hue,
          onChange: onChange
        }), /*#__PURE__*/_jsxs(RibbonContainer, {
          "data-test-id": "ribbon-container",
          children: [/*#__PURE__*/_jsxs(RibbonInner, {
            children: [/*#__PURE__*/_jsx(Ribbon, {
              hue: hue,
              onChange: onChange,
              includeAlpha: includeAlpha
            }), this.renderAlpha({
              alpha,
              hex,
              includeAlpha,
              onChange
            })]
          }), /*#__PURE__*/_jsx(Preview, {
            alpha: alpha,
            hex: hex,
            onChange: onChange,
            onInputClick: this.onSystemColorPickerOpen
          })]
        }), /*#__PURE__*/_jsx(FavoritesAccordion, {
          onSelectColor: onChange,
          favorites: favorites
        })]
      }), /*#__PURE__*/_jsx(Params, {
        hexOnly: hexOnly,
        includeAlpha: includeAlpha,
        alpha: alpha,
        fieldsetSize: fieldsetSize,
        hex: hex,
        hue: hue,
        onChange: onChange,
        mode: mode
      })]
    }));
  }
}
Panel.propTypes = {
  alpha: PropTypes.number,
  favorites: PropTypes.array,
  fieldsetSize: Params.propTypes.fieldsetSize,
  hex: PropTypes.string,
  hexOnly: PropTypes.bool,
  hue: PropTypes.number,
  includeAlpha: PropTypes.bool,
  mode: PropTypes.oneOf(['RGB', 'HSL', 'HSB']),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  cssStyles: PropTypes.object
};